import { nFormatter } from "@/common/utils/parseNumber";

import ImageIcon from "./images/icons/Eye_Show.svg?react";
import VideoIcon from "@/common/images/icons/playIcon.svg?react";
import GalleryIcon from "./images/icons/multipleImagesIcon.svg?react";

import "../buttons.scss";

export enum ViewsButtonType {
  VIDEO = 1,
  IMAGE = 2,
  GALLERY = 4
}

interface IViewsButtonProps {
  count: number;
  onClick?: () => void;
  type?: ViewsButtonType;
}

// TODO: remove later due new design, component: ViewButton
export const ViewsButton: React.FC<IViewsButtonProps> = ({ count, onClick, type }) => {

  const renderIconUrl = () => {
    const { IMAGE, GALLERY } = ViewsButtonType;

    if (type === IMAGE) {
      return <ImageIcon />;
    }

    if (type === GALLERY) {
      return <GalleryIcon />;
    }

    return <VideoIcon />;
  };

  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <button
      className="rg-button views icon"
      onClick={handleClick}
      aria-label={`${nFormatter(count)} views`}
    >
      {renderIconUrl()}
      <div className="label">{nFormatter(count)}</div>
    </button>
  );
};
